import React, {FC} from 'react'
import {Modal} from 'react-bootstrap-v5'
import {fullName} from '../application/ApplicationModel'
import {ITrackingModel} from './TrackingModel'

type Props = {
  tracking: ITrackingModel | null
  onClose: () => void
  onSelect: (nextStepId: string) => void
}

/** Süreç akışında dallanma varsa adayın geçeceği adım seçilir */
export const NextStepModal: FC<Props> = ({tracking, onClose, onSelect}) => (
  <Modal show={!!tracking} onHide={onClose} dialogClassName='modal-dialog-centered'>
    <div className='modal-header'>
      <h5 className='modal-title'>Sonraki Adımı Seçin</h5>
      <button type='button' className='btn-close' onClick={onClose} />
    </div>
    <div className='modal-body'>
      <div className='text-muted mb-5'>
        {tracking && fullName(tracking)} şu anda <strong>{tracking?.currentStepName}</strong> adımında. Bu adımdan
        sonra süreç dallanıyor; adayın geçeceği adımı seçiniz.
      </div>
      <div className='d-flex flex-column gap-3'>
        {tracking?.nextSteps.map((step) => (
          <button
            key={step.id}
            type='button'
            className='btn btn-light-primary text-start d-flex align-items-center justify-content-between'
            onClick={() => onSelect(step.id)}
          >
            <span>
              {step.stepType === 'END' && <i className='bi bi-flag-fill text-success me-2'></i>}
              {step.name}
            </span>
            <i className='bi bi-arrow-right'></i>
          </button>
        ))}
      </div>
    </div>
  </Modal>
)
